import { render, staticRenderFns } from "./EditVictory.vue?vue&type=template&id=2bced2bb&"
import script from "./EditVictory.vue?vue&type=script&lang=js&"
export * from "./EditVictory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports